export const COUNT = 'COUNT';
export const ALPHA = 'ALPHA';
export const METRIC = 'METRIC';